import { type FC } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';
import styles from './styles.scss';

export const ChipPlaceholder: FC<{ className?: string }> = ({ className }) => {
    return (
        <div
            className={classnames(
                styles.chipPlaceholder,
                dibsCss.roundedFull,
                dibsCss.bgMoonstone,
                className
            )}
        />
    );
};
